import React, { useContext, useEffect, useState } from 'react'
import { AdsData, CategoryList, MarketPlaceCategoryList, ServiceListData } from './Views/Marketplace/Service/SubCategory'
import { useNavigate } from 'react-router-dom'
import Overview from '../../components/Dashboard/BusinessDashboard/Overview'
import GigsCart from '../../components/Dashboard/GigsCart'
import MarketplaceCart from '../../components/Dashboard/MarketplaceCart'
import BusinessSummary from '../../components/Dashboard/BusinessDashboard/BusinessSummary'
import ThemeContext from '../../Context/theme/ThemeContext'
import AlertContext from '../../Context/Alert/AlertContext'
import { BaseURL } from '../../Files/BaseURL'
import axios from "axios"

const BusinessDashboard = () => {
    const navigate = useNavigate();
    const { theme } = useContext(ThemeContext);
    // const [SeletedMarketCategory, setSeletedMarketCategory] = useState("Vehicles")

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [services, setServices] = useState([]);
    const [Gigs, setGigs] = useState([]);
    const [SeletedMarketCategory, setSeletedMarketCategory] = useState();
    const [Categories, setCategories] = useState([]);
    const [Products, setProducts] = useState([]);
    const [User, setUser] = useState({});
    const alertcontext = useContext(AlertContext);
    const { showAlert } = alertcontext;

    const fetchServices = async () => {
        try {
            const authToken = localStorage.getItem("p@token");
            const response = await fetch(
                `${BaseURL}/api/marektplace/Service/servicecategoryname`,
                {
                    headers: {
                        "auth-token": authToken,
                    },
                }
            );
            const data = await response.json();
            setServices(data);
            setSelectedCategory(data[0]?._id);
        } catch (error) {
            showAlert("Error fetching Services", "danger");
        }
    };

    useEffect(() => {
        fetchServices();
    }, []);
    const fetchServiceSkills = async (category) => {
        try {
            const authToken = localStorage.getItem("p@token");
            const response = await fetch(
                `${BaseURL}/api/marektplace/Service/industryskill/${category}`,
                {
                    headers: {
                        "auth-token": authToken,
                    },
                }
            );
            const data = await response.json();
            setGigs(data);
        } catch (error) {
            showAlert("Error fetching Service Skills", "danger");
        }
    };

    useEffect(() => {
        if (selectedCategory) {
            fetchServiceSkills(selectedCategory);
        }
    }, [selectedCategory]);

    const fetchCategories = async () => {
        try {
            const response = await axios.get(
                `${BaseURL}/api/product/productcategory`
            );
            setCategories(response.data);
            setSeletedMarketCategory(response?.data[0]?._id);
        } catch (error) {
            showAlert("Error fetching categories", "danger");
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchProducts = async () => {
        try {
            const authToken = localStorage.getItem("p@token");
            const response = await axios.get(
                `${BaseURL}/api/marektplace/products/fetchproducts/${SeletedMarketCategory}`,
                {
                    headers: {
                        "auth-token": authToken,
                    },
                }
            );
            setProducts(response.data);
        } catch (error) {
            showAlert("Error fetching products", "danger");
        }
    };

    useEffect(() => {
        if (SeletedMarketCategory) {
          fetchProducts();
        }
      }, [SeletedMarketCategory]);

    return (
        <div className='w-[95%] m-auto py-6 flex flex-col gap-6'>
            <Overview />

            <BusinessSummary />

            <div className="flex flex-col font-pop gap-4">
                <h2 className="font-pop text-xl font-semibold">Gigs you may like</h2>
                <div className="py-4 flex flex-wrap font-pop items-center gap-2">
                        {services?.map((item, index) => (
                            <div
                                className={`cursor-pointer rounded-2xl py-1 px-2 border-2 font-pop 
                    ${item._id === selectedCategory ? `border-primarygreen  bg-primarygreen/20` : `border-white ${theme == "dark" ? "bg-black text-white" : "bg-white"}`} 
                `}
                                key={index}
                                onClick={() => setSelectedCategory(item._id)}
                            >
                                {item.name}
                            </div>
                        ))}
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 font-pop gap-x-4 gap-y-6">
                    {Gigs?.map((item, index) => (
                        <GigsCart item={item} key={index} />
                    ))}
                </div>
            </div>

            <div className="flex flex-col font-pop gap-4">
                <h2 className="font-pop text-xl font-semibold">
                    Physical Goods you may like
                </h2>

                <div className="py-4 flex flex-wrap font-pop items-center gap-2">
                    {Categories.map((item, index) => (
                        <div
                            className={`cursor-pointer rounded-2xl py-1 px-2 border-2 font-pop ${item._id == SeletedMarketCategory
                                    ? "border-primarygreen bg-primarygreen/20 "
                                    : " border-white"
                                }
               ${theme == "dark" ? "bg-black text-white" : "bg-white "} `}
                            key={index}
                            onClick={() => {
                                setSeletedMarketCategory(item._id);
                            }}
                        >
                            {item.name}
                        </div>
                    ))}
                </div>
{Products.length>0&&
                <div className={`py-4 grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-x-4 gap-y-6`}>
                    {Products?.slice(0, 6)?.map((item, index) => (
                        <MarketplaceCart item={item} key={index} />
                    ))}
                </div>
}
            </div>
        </div>
    )
}

export default BusinessDashboard    